import api from "../api";

export const ACTION_TYPES = {
    LOGIN: 'LOGIN',
    TOKEN_EXPIRED:'TOKEN_EXPIRED'
}

export const login = (data, onError) => dispatch => {
    api.UserProfile().getToken(data)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.LOGIN,
                payload: response
            })
        })
        .catch(err => onError(err))
}